import React from "react";
import Header from "./Header";
import Code from "./code/Code";
import Result from "./Result";

const Home = () => {
  return (
    <>
      <Header />
      <Code />
      <Result />
    </>
  );
};

export default Home;
